import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, database } from "../firebase"; // ✅ Use database, not db
import { ref, set } from "firebase/database"; // ✅ Import Realtime Database functions
import "./Signin.css";
import logo from "../Assets/Sugar Twist ( Logo Files )-09.png";

const SignIn = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ fullName: "", email: "", password: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // Create user with Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
      const user = userCredential.user;
      console.log("User created:", user);
  
      // Store user details in Realtime Database
      await set(ref(database, "users/" + user.uid), {
        fullName: formData.fullName,
        email: formData.email,
        createdAt: new Date().toISOString(),
      });

      alert("Signup successful! Please login.");
      
      setTimeout(() => {
        navigate("/login");
      }, 500);
    } catch (error) {
      console.error("Signup Error:", error.message);
      alert(error.message);
    }
  };

  return (
    <div className="container">
      <div className="form-container">
        <h1 style={{ marginBottom: "2rem" }}>Sign Up</h1>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input type="text" name="fullName" placeholder="Full Name" required value={formData.fullName} onChange={handleChange} />
          </div>

          <div className="input-group">
            <input type="email" name="email" placeholder="Email" required value={formData.email} onChange={handleChange} />
          </div>

          <div className="input-group">
            <input type="password" name="password" placeholder="Password" required value={formData.password} onChange={handleChange} />
          </div>

          <button type="submit" className="submit-button">Sign Up</button>
        </form>

        <p className="terms">
          Already have an account? <span onClick={() => navigate("/login")}>Log In</span>
        </p>
      </div>

      <div className="illustration">
        <img src={logo} alt="Illustration" className="illustration-image" />
      </div>
    </div>
  );
};

export default SignIn;
